import ScreenSizes from '../constants/ScreenSizes';

export default class PictureMedia {
  picture: HTMLElement;
  src: string;
  alt: string;

  /**
   * Create a new instance of a PictureMedia
   */
  constructor(picture: HTMLElement, { src, alt }) {
    this.picture = picture.cloneNode(true);
    this.src = src;
    this.alt = alt;
  }

  /**
   * build an Image element with different media query sources.
   * loops on height, uses height and width.
   * to build a image width and height are both required They don't work separately
   */
  build(): HTMLElement {
    const image = this.picture.getElementByRef('image');
    image.src = `${this.src}?auto=format`;
    image.alt = this.alt;
    const sizes = JSON.parse(image.dataset.sizes);

    while (this.picture.firstChild) {
      this.picture.removeChild(this.picture.lastChild);
    }

    for (const size in sizes.height) {
      const source: string = this.createSource(
        ScreenSizes.abbreviationToScreenSize(size),
        `${this.src}?auto=format&width=${sizes.width[size]}&height=${sizes.height[size]}&dpr=1 1x,
               ${this.src}?auto=format&width=${sizes.width[size]}&height=${sizes.height[size]}&dpr=1.25 1.25x,
               ${this.src}?auto=format&width=${sizes.width[size]}&height=${sizes.height[size]}&dpr=2 2x`
      );

      this.picture.prepend(source);
    }

    this.picture.append(image);

    return this.picture;
  }

  /**
   * Create a new media source
   */
  createSource(breakpoint: string, srcset: string): HTMLElement {
    const temporaryElement = document.createElement('div');
    temporaryElement.innerHTML = `<source media="(min-width: ${breakpoint}px)" srcset="${srcset}"/>`;
    return temporaryElement.firstElementChild;
  }
}
